module.exports = __webpack_public_path__ + "img/setUnit.eabe8372.svg";